import { isTestable } from '@ecosconnect/core/src/helpers/backflow/helpers';
import {
  AssemblyTypeKey,
  JobFormDataInput,
  RpCheck2Type,
  TestRepair,
  TestResult,
} from '@ecosconnect/core/src/types/jobFormData';
import BackflowTestResult from './result/BackflowTestResult';
import Accordion from '../Accordion/Accordion';
import AccordionItem from '../Accordion/AccordionItem';
import React from 'react';

type BackflowTestReportProps = {
  formData: JobFormDataInput;
  assemblyType?: AssemblyTypeKey;
  rpCheck2Type: RpCheck2Type;
};

const BackflowTestReport: React.FC<BackflowTestReportProps> = ({
  formData,
  assemblyType,
  rpCheck2Type,
}) => {
  return (
    <>
      {/*{(formAssembly || originalBackflowAssembly) && (*/}
      {/*  <BackflowTestAssembly*/}
      {/*    originalBackflowAssembly={originalBackflowAssembly}*/}
      {/*    backflowAssemblyId={backflowAssemblyId}*/}
      {/*    formAssembly={formAssembly}*/}
      {/*    formData={formData}*/}
      {/*  />*/}
      {/*)}*/}

      {isTestable(formData) &&
        assemblyType &&
        formData.tests &&
        (formData.tests as any[]).map(
          (test: TestResult | TestRepair, index) => (
            <BackflowTestResult
              key={index}
              index={index}
              test={test}
              assemblyType={assemblyType as AssemblyTypeKey}
              rpCheck2Type={rpCheck2Type}
            />
          )
        )}

      <Accordion title="Additional">
        {typeof formData.meterReading === 'number' && (
          <AccordionItem label="Meter Reading" value={formData.meterReading} />
        )}
        <AccordionItem
          label="Shutoff 1 Position"
          value={
            formData.shutoff1Position === undefined
              ? 'Unknown'
              : formData.shutoff1Position === 1
                ? 'Open'
                : 'Closed'
          }
        />
        <AccordionItem
          label="Shutoff 2 Position"
          value={
            formData.shutoff2Position === undefined
              ? 'Unknown'
              : formData.shutoff2Position === 1
                ? 'Open'
                : 'Closed'
          }
        />
      </Accordion>
    </>
  );
};

export default BackflowTestReport;
